const ITEMS = [
  {
    icon: "ri-plane-line",
    title: "일본 여행에서 직접 말하고 싶은 분",
    desc: "공항, 식당, 쇼핑까지 필요한 회화를 내 입으로 자연스럽게 꺼내고 싶은 분",
  },
  {
    icon: "ri-play-circle-line",
    title: "일본 드라마·애니·음악을 이해하고 싶은 분",
    desc: "자막 없이 좋아하는 콘텐츠의 대사와 가사를 조금씩 알아듣고 싶은 분",
  },
  {
    icon: "ri-book-2-line",
    title: "기초 문법을 체계적으로 배우고 싶은 분",
    desc: "여러 강의를 왔다갔다 하지 않고, 한 번에 기초를 잡고 싶은 학습자",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "일본어를 처음 시작하는 완전 초보자",
    desc: "히라가나부터 차근차근, 무리 없이 8주 동안 함께 걸어갈 완전 초보",
  },
  {
    icon: "ri-user-heart-line",
    title: "일본어를 배우고 싶었지만 혼자서는 꾸준히 하기 어려웠던 분",
    desc: "매번 작심삼일로 끝났던 일본어, 이번엔 소수정예로 함께하며 끝까지 완주해요.",
  },
];

export default function Recommend() {
  return (
    <section id="intro" className="py-10 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        <div className="text-center mb-12">
          <span className="text-[10px] md:text-sm font-semibold tracking-widest text-primary-600 uppercase">
            For Beginners
          </span>
          <h2 className="mt-3 font-heading text-xl md:text-4xl font-bold text-foreground-950">
            이런 분께 추천해요
          </h2>
          <p className="mt-2 text-xs sm:text-base text-foreground-700">
            이런 고민이 있다면, 이 수업이 딱 맞아요.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {ITEMS.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200 rounded-xl p-3 sm:p-6 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 w-full sm:w-[calc(50%-6px)] lg:w-[calc(33.333%-8px)]"
            >
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 sm:w-14 sm:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 text-lg sm:text-2xl shrink-0">
                  <i className={item.icon}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-sm sm:text-lg font-bold text-foreground-950 leading-snug break-all">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs sm:text-sm text-foreground-700 leading-relaxed break-all">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}